"use client";

import { LoginCredentialsForm } from "./LoginCredentialsForm";
import { PasswordInput } from "@/components/forms/PasswordInput";

import { useEffect, useState } from "react";
import { isLocalTestPage, readLocalTestAccount, type TestAccountFill } from "./local-test-account-client";

export function EmailLoginForm({ next, testAccount, helperToken }: { next: string; testAccount?: string; helperToken?: string }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [notice, setNotice] = useState("");
  useEffect(() => {
    if (!helperToken || !testAccount || !isLocalTestPage()) return;
    const controller = new AbortController();
    void readLocalTestAccount<TestAccountFill>("fill", helperToken, { identity: testAccount }, controller.signal).then(value => {
      setEmail(value.email); setPassword(value.password); setNotice("");
    }).catch(() => { if (!controller.signal.aborted) setNotice("本机快捷填充暂不可用，请重新选择账号。"); });
    return () => controller.abort();
  }, [testAccount, helperToken]);
  const fieldClass = "rounded-[var(--radius-input)] border border-[var(--color-line-strong)] bg-[var(--color-sunken)] px-4 py-3 text-sm text-[var(--color-paper)] outline-none focus:border-[var(--color-accent)]";
  return <div className="grid gap-4">
    {notice && <p role="status" className="text-sm text-[var(--color-accent)]">{notice}</p>}
    <LoginCredentialsForm action="/api/auth/login" method="post"
      hiddenFields={<input type="hidden" name="next" value={next} />}
      identity={{ label: "邮箱", control: <input required name="email" type="email" autoComplete="email" placeholder="请输入邮箱" value={email} onChange={event => setEmail(event.target.value)} className={fieldClass} /> }}
      credential={{ label: "密码", control: <PasswordInput required name="password" autoComplete="current-password" placeholder="请输入密码" value={password} onChange={event => setPassword(event.target.value)} /> }}
      submit={<button className="rg-primary">登录</button>}
    />
  </div>;
}
